import _ from 'lodash';
import { apiSearch } from './utility';

export const searchStationHistory = (p = {}) => {
	const callback = p.callback || _.noop;
	return dispatch => {
		apiSearch({
			method : 'station.history.search',
			base : 'stationHistory',
			dispatch : dispatch,
			callback : callback,
		});
	};
};
